export const STATES = {
  ACTIVE: 'active',
  COMPLETED: 'completed',
  INCOMPLETE: 'incomplete',
  ERROR: 'error',
  DISABLED: 'disabled',
};

export const ICON_SIZES = {
  ACTIVE: 32,
  OTHER: 28,
};
